import React from 'react';
import {GeneratedVideoChunk} from '../../../data/models/LibraryFile/GeneratedVideoChunk';
import {EditChunkOption} from '../../../data/repositories/LibraryRepository';
import {DraggableChunks} from './DraggableChunks';
interface Props {
  chunks: GeneratedVideoChunk[];
  selectedChunk?: GeneratedVideoChunk;
  onEditChunk: (option: EditChunkOption, chunkId: string) => void;
  onSelectChunk: (chunk: GeneratedVideoChunk) => void;
  totalTimelineSeconds: number;
  pixelsPerSecond: number;
  onChunksReorder: (
    chunks: GeneratedVideoChunk[],
    activeChunkId: string,
    newIndex: number,
  ) => void;
}

const ChunkList: React.FC<Props> = ({
  chunks,
  selectedChunk,
  onEditChunk,
  onSelectChunk,
  totalTimelineSeconds,
  pixelsPerSecond,
  onChunksReorder,
}) => {
  return (
    <DraggableChunks
      chunks={chunks}
      selectedChunk={selectedChunk}
      onEditChunk={onEditChunk}
      onSelectChunk={onSelectChunk}
      onChunksReorder={onChunksReorder}
      totalTimelineSeconds={totalTimelineSeconds}
      pixelsPerSecond={pixelsPerSecond}
    />
  );
};

export default React.memo(ChunkList);
